<template>
  <div>
    <h2 class="title">User Details</h2>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Username</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input
              class="input is-static"
              :value="userById.username"
              readonly
            />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Email Address</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input class="input is-static" :value="userById.email" readonly />
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Admin/Menu'
import { USER_QUERY } from '@/graphql'

export default {
  name: 'UserDetails',
  components: {
    Menu
  },
  data () {
    return {
      userById: '',
      id: this.$route.params.id
    }
  },
  apollo: {
    // fetch user by ID
    userById: {
      query: USER_QUERY,
      variables () {
        return {
          id: parseInt(this.id)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/UserDetails.vue